<div [formGroup]="group" [ngSwitch]="question.selectionType">
    <div *ngSwitchCase="'radio'" class="u-margin-bottom-double" [ngSwitch]="surveySandbox.hasChildren(question?.options)">
        <app-label-container
            *ngSwitchCase="true"
            [required]="required"
            [id]="question.id"
            [label]="question | questionTitle"
            [hasMargin]="true"
        >
            <app-multi-select-input [question]="question" [group]="group" formControlName="value" [options]="selectionOptions">
            </app-multi-select-input>
        </app-label-container>
        <app-select-input
            *ngSwitchCase="false"
            [custom]="false"
            [hasMargin]="false"
            [hasMarginDouble]="true"
            [formControlName]="'value'"
            [label]="question | questionTitle"
            [options]="selectionOptions"
        ></app-select-input>
    </div>

    <div *ngSwitchCase="'checkbox'" class="u-margin-bottom-double">
        <app-label-container [required]="required" [id]="question.id" [label]="question | questionTitle" [hasMargin]="true">
            <div class="u-flex-wrap" [formGroup]="group.get('other')">
                <app-check-input
                    *ngFor="let option of checkOptions"
                    [custom]="false"
                    [option]="option"
                    style="flex: 0 50%"
                    [formControlName]="option.value"
                ></app-check-input>
            </div>
        </app-label-container>
    </div>
</div>
